export default __webpack_public_path__ + "static/media/simon_judkins.212a8f51.jpg";